module.exports = __webpack_public_path__ + "img/axatp009.a2d34be5.jpg";